'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef, useEffect, useState } from 'react';
import Image from 'next/image';
import gsap from 'gsap';
interface ProfileGlitchProps {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  glitchIntensity?: number;
  glitchFrequency?: number;
  randomGlitch?: boolean;
  minGlitchInterval?: number;
  maxGlitchInterval?: number;
}
export { ProfileGlitch };
function ProfileGlitch(t0) {
  const $ = _c(45);
  const {
    src,
    alt,
    width: t1,
    height: t2,
    glitchIntensity: t3,
    glitchFrequency: t4,
    randomGlitch: t5,
    minGlitchInterval: t6,
    maxGlitchInterval: t7
  } = t0;
  t1 === undefined ? 192 : t1;
  t2 === undefined ? 192 : t2;
  const glitchIntensity = t3 === undefined ? 8 : t3;
  const glitchFrequency = t4 === undefined ? 0.15 : t4;
  const randomGlitch = t5 === undefined ? true : t5;
  const minGlitchInterval = t6 === undefined ? 2000 : t6;
  const maxGlitchInterval = t7 === undefined ? 5000 : t7;
  const containerRef = useRef(null);
  let t8;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [];
    $[0] = t8;
  } else {
    t8 = $[0];
  }
  const glitchLayers = useRef(t8);
  const glitchTimelineRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const [isGlitching, setIsGlitching] = useState(false);
  const scanlineRef = useRef(null);
  const glitchIntervalRef = useRef(null);
  let t9;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = [];
    $[1] = t9;
  } else {
    t9 = $[1];
  }
  useEffect(_temp, t9);
  let t10;
  if ($[2] !== glitchIntensity || $[3] !== isHovered) {
    t10 = () => {
      const tl = gsap.timeline({
        repeat: isHovered ? -1 : 0,
        onComplete: () => {
          setIsGlitching(false);
        }
      });
      const glitchSequence = [{
        time: 0.2,
        duration: 0.06
      }, {
        time: 0.5,
        duration: 0.08
      }, {
        time: 0.9,
        duration: 0.04
      }, {
        time: 1.2,
        duration: 0.07
      }];
      glitchLayers.current.forEach((layer, index) => {
        const baseOffset = (index - 1) * 3;
        glitchSequence.forEach(glitch => {
          const randomX = (Math.random() - 0.5) * glitchIntensity * 2;
          const randomY = (Math.random() - 0.5) * glitchIntensity;
          tl.to(layer, {
            x: randomX + baseOffset,
            y: randomY,
            opacity: 0.6 + Math.random() * 0.2,
            duration: glitch.duration,
            ease: "none"
          }, glitch.time + index * 0.015);
          tl.to(layer, {
            x: baseOffset,
            y: 0,
            opacity: 0.6,
            duration: glitch.duration * 1.2,
            ease: "power2.out"
          }, "<0.03");
        });
      });
      if (containerRef.current) {
        const baseImage = containerRef.current.querySelector(".base-layer") as HTMLElement;
        glitchSequence.forEach(glitch_0 => {
          tl.to(baseImage, {
            scale: 1.02,
            duration: glitch_0.duration * 0.5,
            ease: "none"
          }, glitch_0.time);
          tl.to(baseImage, {
            scale: 1,
            duration: glitch_0.duration * 0.5,
            ease: "power2.out"
          }, "<");
        });
      }
      return tl;
    };
    $[2] = glitchIntensity;
    $[3] = isHovered;
    $[4] = t10;
  } else {
    t10 = $[4];
  }
  const createGlitchTimeline = t10;
  let t11;
  if ($[5] !== createGlitchTimeline || $[6] !== glitchFrequency || $[7] !== isHovered || $[8] !== maxGlitchInterval || $[9] !== minGlitchInterval || $[10] !== randomGlitch) {
    t11 = () => {
      if (!randomGlitch) {
        return;
      }
      const scheduleNextGlitch = () => {
        const interval = Math.random() * (maxGlitchInterval - minGlitchInterval) + minGlitchInterval;
        glitchIntervalRef.current = setTimeout(() => {
          if (!isHovered) {
            setIsGlitching(true);
            glitchTimelineRef.current?.kill();
            glitchTimelineRef.current = createGlitchTimeline();
            glitchTimelineRef.current.timeScale(2 - glitchFrequency);
          }
          scheduleNextGlitch();
        }, interval);
      };
      scheduleNextGlitch();
      return () => {
        if (glitchIntervalRef.current) {
          clearTimeout(glitchIntervalRef.current);
        }
      };
    };
    $[5] = createGlitchTimeline;
    $[6] = glitchFrequency;
    $[7] = isHovered;
    $[8] = maxGlitchInterval;
    $[9] = minGlitchInterval;
    $[10] = randomGlitch;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== glitchFrequency || $[13] !== maxGlitchInterval || $[14] !== minGlitchInterval || $[15] !== randomGlitch) {
    t12 = [randomGlitch, minGlitchInterval, maxGlitchInterval, glitchFrequency];
    $[12] = glitchFrequency;
    $[13] = maxGlitchInterval;
    $[14] = minGlitchInterval;
    $[15] = randomGlitch;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  useEffect(t11, t12);
  let t13;
  if ($[17] !== createGlitchTimeline || $[18] !== glitchFrequency || $[19] !== isHovered) {
    t13 = () => {
      if (!containerRef.current) {
        return;
      }
      glitchTimelineRef.current?.kill();
      if (!isHovered) {
        return;
      }
      glitchTimelineRef.current = createGlitchTimeline();
      glitchTimelineRef.current.timeScale(2 - glitchFrequency);
      return () => {
        glitchTimelineRef.current?.kill();
      };
    };
    $[17] = createGlitchTimeline;
    $[18] = glitchFrequency;
    $[19] = isHovered;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== glitchFrequency || $[22] !== glitchIntensity || $[23] !== isHovered) {
    t14 = [isHovered, glitchIntensity, glitchFrequency];
    $[21] = glitchFrequency;
    $[22] = glitchIntensity;
    $[23] = isHovered;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  useEffect(t13, t14);
  let t15;
  let t16;
  let t17;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      perspective: "1000px"
    };
    t16 = () => setIsHovered(true);
    t17 = () => setIsHovered(false);
    $[25] = t15;
    $[26] = t16;
    $[27] = t17;
  } else {
    t15 = $[25];
    t16 = $[26];
    t17 = $[27];
  }
  let t18;
  if ($[28] !== alt || $[29] !== src) {
    t18 = <div className="base-layer absolute inset-0 rounded-full overflow-hidden will-change-transform"><Image src={src} alt={alt} fill={true} priority={true} sizes="(max-width: 768px) 128px, 192px" className="object-cover group-hover:brightness-110 transition-brightness duration-300" /></div>;
    $[28] = alt;
    $[29] = src;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = [0, 1, 2];
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== alt || $[33] !== src) {
    t20 = t19.map(index_0 => <div key={index_0} ref={el => {
      if (el) {
        glitchLayers.current[index_0] = el;
      }
    }} aria-hidden="true" className="absolute inset-0 rounded-full overflow-hidden pointer-events-none will-change-transform" style={{
      opacity: 0.6,
      transform: `translate(${(index_0 - 1) * 3}px, 0)`,
      mixBlendMode: index_0 === 0 ? "screen" : index_0 === 1 ? "multiply" : "lighten"
    }}><Image src={src} alt={alt} width={192} height={192} loading="eager" className="object-cover w-full h-full" /></div>);
    $[32] = alt;
    $[33] = src;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  const t21 = isHovered || isGlitching ? "glitch-scan 8s linear infinite" : "none";
  let t22;
  if ($[35] !== t21) {
    t22 = <div ref={scanlineRef} className="absolute inset-0 rounded-full pointer-events-none" style={{
      background: "repeating-linear-gradient(\n              0deg,\n              rgba(255, 255, 255, 0.03),\n              rgba(255, 255, 255, 0.03) 1px,\n              transparent 1px,\n              transparent 2px\n            )",
      animation: t21
    }} />;
    $[35] = t21;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  const t23 = isHovered || isGlitching ? "rgba(99, 102, 241, 0.5)" : "rgba(99, 102, 241, 0.2)";
  const t24 = isHovered || isGlitching ? "0 0 20px rgba(99, 102, 241, 0.3) inset" : "none";
  let t25;
  if ($[37] !== t23 || $[38] !== t24) {
    t25 = <div className="absolute inset-0 rounded-full border-2 pointer-events-none transition-all duration-300" style={{
      borderColor: t23,
      boxShadow: t24
    }} />;
    $[37] = t23;
    $[38] = t24;
    $[39] = t25;
  } else {
    t25 = $[39];
  }
  let t26;
  if ($[40] !== t18 || $[41] !== t20 || $[42] !== t22 || $[43] !== t25) {
    t26 = <div className="relative"><div ref={containerRef} className="relative w-32 h-32 md:w-48 md:h-48 mx-auto rounded-full overflow-hidden border-2 border-primary/20 cursor-pointer group" style={t15} onMouseEnter={t16} onMouseLeave={t17}>{t18}{t20}{t22}{t25}</div></div>;
    $[40] = t18;
    $[41] = t20;
    $[42] = t22;
    $[43] = t25;
    $[44] = t26;
  } else {
    t26 = $[44];
  }
  return t26;
}
function _temp() {
  if (!document.getElementById("glitch-scanline-style")) {
    const style = document.createElement("style");
    style.id = "glitch-scanline-style";
    style.textContent = "\n        @keyframes glitch-scan {\n          0% { transform: translateY(0); }\n          100% { transform: translateY(4px); }\n        }\n        @keyframes glitch-flicker {\n          0%, 100% { opacity: 0.6; }\n          50% { opacity: 0.8; }\n        }\n      ";
    document.head.appendChild(style);
  }
}